<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'meteringpoint.meternumber' | translate }}</label>
    <select
      appSelect
      formControlName="meterNumber"
    >
      <option value="null" selected disabled>{{ 'meteringpoint.meter.selectmeter' | translate }}</option>
      @for (item of meterList; track item.id) {
        <option [value]="item.meterNumber">
          {{ item.serialNumber ? `Serienummer: ${item.serialNumber}` : '' }} {{ item.alternateMeterNumber ? `- Placering: ${item.alternateMeterNumber}` : '' }} {{ item.meterNumber ? `- Målernummer: ${item.meterNumber}` : 'Ingen målernummer' }}
        </option>
      }
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meteringpoint.serialnumber' | translate }}</label>
    <input type="text" appInput formControlName="serialNumber" readonly [placeholder]="'meteringpoint.serialnumber' | translate">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meteringpoint.unittype' | translate }}</label>
    <select appSelect formControlName="unitType" [collection]="unitType">
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>Målertype</label>
    <select appSelect formControlName="meterReadingType" [collection]="meterReadingType">
      <option disabled value="null" selected>Vælg målertype</option>
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>Målepunktsart</label>
    <input type="text" appInput value="Fysisk" readonly>
  </app-input-group>

  <app-input-group>
    <label appLabel>Skæringspunkt</label>
    <input type="date" appInputDate formControlName="validFrom">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'common.quadrant' | translate }}</label>
    <select appSelect formControlName="quadrant" [collection]="quadrant">
    </select>
  </app-input-group>
</form>
